"use client";

import { useCurrentOrganization } from "@/hooks/spacetime";
import { UpdateDialogContent } from "./update-dialog-content";

export function UpdateDialog() {
  const { organization, isReady } = useCurrentOrganization();
  return (
    <UpdateDialogContent autoShowEligible={isReady ? !!organization : null} />
  );
}
